import {
  COMPANY,
  DO_NOT_SHIP,
  DROPSHIP
} from "MODULES/PurchaseOrders/constants";
import {
  hasCreditAndWarranty,
  hasWarrantyAndNotCredit,
  rmaIsClosed
} from "MODULES/shared/helpers";
import {
  ACTION_REQUESTED,
  APPROVAL_STATUS,
  EXCHANGE_GONE_OUTRIGHT,
  FINAL_EVALUATION_APPROVED,
  INCOMING_AWB_NUMBER,
  INTERNAL_OUTRIGHT,
  NO_WORK_PERFORMED,
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_RECEIVED,
  REPAIR_EVALUATION_REJECTED,
  SHOP_ASSIST
} from "MODULES/RepairOrders/constants";
import _ from "lodash";
import { getFormInitialValues, isDirty } from "redux-form";
import {
  RETURN_TO_COMPANY_ADDRESS_ID,
  RETURN_TO_COMPANY_ID,
  RETURN_TO_SHIPPING_ADDRESS,
  RETURN_TO_SHIPPING_METHOD,
  RETURN_TO_TYPE,
  SHIPPED
} from "APP_ROOT/constants";
import { REPAIR_AND_HOLD } from "MODULES/inventories/constants";
import { TENANT_LOCATION } from "MODULES/shared/components/ShippingSection/shippingTypes";

export const getLocationsAndReturnToTypes = (
  editing,
  hasGoneOutright,
  selectedInventory
) => {
  let returnToTypes = [COMPANY, DROPSHIP, DO_NOT_SHIP];
  let hasLocations = true;

  const rmaPath = editing
    ? "inventory.most_recent_customer_rma"
    : "most_recent_customer_rma";

  if (
    hasCreditAndWarranty(selectedInventory, rmaPath) &&
    !rmaIsClosed(selectedInventory, rmaPath) &&
    !hasGoneOutright
  ) {
    returnToTypes = [];
  }

  if (hasWarrantyAndNotCredit(selectedInventory, rmaPath) && !hasGoneOutright) {
    returnToTypes = [COMPANY, DROPSHIP];
    hasLocations = true;
  }

  return [hasLocations, returnToTypes];
};

export const getOutrightVal = getFieldValue =>
  getFieldValue(EXCHANGE_GONE_OUTRIGHT) || getFieldValue(INTERNAL_OUTRIGHT);

export const getDisplayShipmentVal = (state, formName) =>
  _.get(getFormInitialValues(formName)(state), INCOMING_AWB_NUMBER) &&
  [
    RETURN_TO_SHIPPING_METHOD,
    RETURN_TO_TYPE,
    INCOMING_AWB_NUMBER,
    RETURN_TO_SHIPPING_ADDRESS,
    RETURN_TO_COMPANY_ID,
    RETURN_TO_COMPANY_ADDRESS_ID
  ].some(f => isDirty(formName)(state, f));

export const getDisableReturnFields = (disabled, getField) => {
  const approvalStatus = getField(APPROVAL_STATUS);
  const repairAndHold = getField(REPAIR_AND_HOLD);
  const finalEval = getField(FINAL_EVALUATION_APPROVED);

  return (
    (repairAndHold && !finalEval) ||
    disabled ||
    (![
      REPAIR_EVALUATION_RECEIVED,
      REPAIR_EVALUATION_REJECTED,
      REPAIR_EVALUATION_APPROVED,
      NO_WORK_PERFORMED
    ].includes(approvalStatus) &&
      getField(ACTION_REQUESTED) !== SHOP_ASSIST)
  );
};

export const isDropshipping = ({
  getFieldValue,
  repairItem,
  getInitialFieldValue
}) => {
  const returnToType = getFieldValue(RETURN_TO_TYPE);

  return (
    TENANT_LOCATION !== returnToType &&
    DO_NOT_SHIP !== returnToType &&
    !repairItem.received &&
    hasDropshippedOrder(repairItem) &&
    _.isEmpty(getInitialFieldValue(INCOMING_AWB_NUMBER)) &&
    !_.isEmpty(getFieldValue(INCOMING_AWB_NUMBER))
  );
};

function hasDropshippedOrder(repairItem) {
  return (
    isDropshippedSales(repairItem) ||
    (_.get(repairItem, ["inventory", "most_recent_managed_repair"].join(".")) &&
      !_.get(
        repairItem,
        ["inventory", "most_recent_managed_repair", SHIPPED].join(".")
      ))
  );
}

export function isDropshippedSales(repairItem) {
  return (
    _.get(repairItem, ["inventory", "most_recent_sales_order"].join(".")) &&
    !_.get(
      repairItem,
      ["inventory", "most_recent_sales_order", SHIPPED].join(".")
    )
  );
}



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/LineItems/helpers.js